import React from 'react';
import { RadioGroup as ChakraRadioGroup, HStack, VStack, Text } from '@chakra-ui/react';

export const RadioGroup = ChakraRadioGroup;

interface RadioProps {
  value: string;
  children: React.ReactNode;
}

export function Radio({ value, children }: RadioProps) {
  // Check if children is an object with text and description
  const hasComplexContent = React.isValidElement(children) && children.props;
  
  if (hasComplexContent) {
    return (
      <RadioGroup.Item value={value}>
        <RadioGroup.ItemControl>
          <RadioGroup.ItemIndicator />
        </RadioGroup.ItemControl>
        {children}
      </RadioGroup.Item>
    );
  }
  
  return (
    <RadioGroup.Item value={value}>
      <RadioGroup.ItemControl>
        <RadioGroup.ItemIndicator />
      </RadioGroup.ItemControl>
      <RadioGroup.ItemText>{children}</RadioGroup.ItemText>
    </RadioGroup.Item>
  );
}